export const formatPath = (url?: string) => {
  if (url === undefined) return
  const urlAsArray = urlStringToArray(url) || []

  const path = urlArrayToString(urlAsArray) || '/'

  // Ensure trailing slash (matches gatsby-config trailingSlash: 'always')
  // Skip paths with anchors, query strings, or file extensions (e.g. /file.pdf)
  const lastSegment = path.split('/').filter(Boolean).pop() ?? ''
  const hasFileExtension = /\.\w{2,5}$/.test(lastSegment)
  if (path !== '/' && !path.endsWith('/') && !path.includes('#') && !path.includes('?') && !hasFileExtension) {
    return path + '/'
  }

  return path
}

export const urlStringToArray = (url?: string): string[] | undefined => {
  if (!url) return

  const urlArray = url.match(/[^\/]*(?:[^\/])/g)

  if (!urlArray) return

  return urlArray
}
export const urlArrayToString = (urlAsArray: string[]) =>
  urlAsArray.reduce((acc, curr) => {
    if (curr?.length > 0) {
      return acc + '/' + curr
    }
    return acc
  }, '')
